import React from "react";

const Nav = () => {
  const links = [
    { label: "Home", href: "/" },
    { label: "About", href: "#about" },
    { label: "Services", href: "#services" },
    { label: "Why Us", href: "#why-us" },
    { label: "Testimonials", href: "#testimonials" },
    { label: "Contact", href: "#contact" },
  ];

  return (
    <>
      {/* NAVBAR */}
      <nav className="navbar navbar-expand-lg navbar-light bg-white sticky-top shadow-sm">
        <div className="container">
          <a
            className="navbar-brand fw-bold d-flex align-items-center navcolor"
            href="/"
          >
            <img
              src="/img/logo.png"
              alt="logo"
              style={{ width: "40px", marginRight: "10px" }}
            />
            5 Helms Consulting
          </a>

          <button
            className="navbar-toggler"
            type="button"
            data-bs-toggle="collapse"
            data-bs-target="#mainNavbar"
          >
            <span className="navbar-toggler-icon"></span>
          </button>

          <div className="collapse navbar-collapse" id="mainNavbar">
            <ul className="navbar-nav mx-auto">
              {links.map((item, index) => (
                <li key={index} className="nav-item px-2">
                  <a className="nav-link navcolor" href={item.href}>
                    {item.label}
                  </a>
                </li>
              ))}
            </ul>

            <div className="d-flex gap-2">
              <button
                className="btn btn-outline-primary px-4 navcolor"
                data-bs-toggle="modal"
                data-bs-target="#loginModal"
              >
                Login
              </button>

              <a href="#contact" className="btn btn-primary px-4">
                Get Started
              </a>
            </div>
          </div>
        </div>
      </nav>

      {/* LOGIN MODAL */}
      <div
        className="modal fade"
        id="loginModal"
        tabIndex="-1"
        aria-hidden="true"
      >
        <div className="modal-dialog modal-dialog-centered">
          <div className="modal-content">
            <div className="modal-header">
              <h5 className="modal-title modal-title-red w-100 text-center">
                Login
              </h5>
              <button
                type="button"
                className="btn-close"
                data-bs-dismiss="modal"
              ></button>
            </div>

            <div className="modal-body">
              <form>
                {/* EMAIL */}
                <div className="mb-3">
                  <label className="form-label">Email</label>
                  <div className="input-group">
                    <span className="input-group-text">
                      <i className="bi bi-envelope"></i>
                    </span>
                    <input
                      type="email"
                      className="form-control"
                      placeholder="admin@example.com"
                    />
                  </div>
                </div>

                {/* PASSWORD */}
                <div className="mb-3">
                  <label className="form-label">Password</label>
                  <div className="input-group">
                    <span className="input-group-text">
                      <i className="bi bi-lock"></i>
                    </span>
                    <input
                      type="password"
                      className="form-control"
                      placeholder="••••••••"
                    />
                  </div>
                </div>

                <button type="submit" className="btn btn-primary w-100">
                  Login
                </button>
              </form>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default Nav;
